import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=6d75f7d6&scoped=true"
import script from "./home-footer.vue?vue&type=script&lang=js"
export * from "./home-footer.vue?vue&type=script&lang=js"
import style0 from "./home-footer.vue?vue&type=style&index=0&id=6d75f7d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d75f7d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d75f7d6')) {
      api.createRecord('6d75f7d6', component.options)
    } else {
      api.reload('6d75f7d6', component.options)
    }
    module.hot.accept("./home-footer.vue?vue&type=template&id=6d75f7d6&scoped=true", function () {
      api.rerender('6d75f7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/home-footer.vue"
export default component.exports